var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Manage Shareable Project Template Links"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h4", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", [
                        _c("div", { staticClass: "alert alert-info" }, [
                          _vm._v(
                            "\n                            Share your project '"
                          ),
                          _c("strong", [_vm._v(_vm._s(_vm.projectName))]),
                          _vm._v(
                            "' as a template using web links. Start by assigning each link a descriptive name to track its purpose.\n                            After naming your links, click 'Save'. The links will then be automatically generated and ready to share.\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group my-2" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.newLinkName,
                                expression: "newLinkName",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "new link name...",
                            },
                            domProps: { value: _vm.newLinkName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.newLinkName = $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.createLink },
                              },
                              [_vm._v("Create link")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.links.length > 0
                          ? _c(
                              "table",
                              {
                                staticClass: "table table-bordered table-hover",
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.links, function (l) {
                                    return _c("tr", { key: l.Id }, [
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: l.Name,
                                              expression: "l.Name",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Your link name",
                                          },
                                          domProps: { value: l.Name },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                l,
                                                "Name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        l.Name && l.Id > 0
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: l.AccessUrl,
                                                  expression: "l.AccessUrl",
                                                },
                                              ],
                                              staticClass:
                                                "form-control pointer",
                                              attrs: {
                                                type: "text",
                                                title: "Click to copy",
                                                readonly: "",
                                              },
                                              domProps: { value: l.AccessUrl },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyAccessUrlToClipboard(
                                                    l
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    l,
                                                    "AccessUrl",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        l.Name && l.Id === 0
                                          ? _c("input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                readonly: "",
                                              },
                                              domProps: {
                                                value: "Save to generate url",
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        l.Name
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(l.Views) +
                                                  " / " +
                                                  _vm._s(l.Downloads) +
                                                  "\n                                        "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        l.Name
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-secondary",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteLink(l)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.error)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", disabled: _vm.updating },
                      on: { click: _vm.handleUpdateLinks },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.updating ? "Saving..." : "Save") +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button", disabled: _vm.updating },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Link name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Url (click to copy)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Views / Downloads")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }